import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11 7h6v2h-6zm0 4h6v2h-6zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7zM3 3v18h18V3H3zm16 16H5V5h14v14z"
}), 'ListAltSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ListAltSharp.js
// module id = 4510
// module chunks = 2